/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckChecklistItemRequirement } from './PaxCheckChecklistItemRequirement';
import {
    PaxCheckChecklistItemRequirementFromJSON,
    PaxCheckChecklistItemRequirementFromJSONTyped,
    PaxCheckChecklistItemRequirementToJSON,
    PaxCheckChecklistItemRequirementToJSONTyped,
} from './PaxCheckChecklistItemRequirement';

/**
 * Composed checklist item requirement: Or([ChecklistItemRequirement])
 * @export
 * @interface PaxCheckComposedOr
 */
export interface PaxCheckComposedOr {
    /**
     * Requirement represented as text
     * @type {string}
     * @memberof PaxCheckComposedOr
     */
    asText: string;
    /**
     * Embedded requirements as a list (... or ... or ...)
     * @type {Array<PaxCheckChecklistItemRequirement>}
     * @memberof PaxCheckComposedOr
     */
    requirements: Array<PaxCheckChecklistItemRequirement>;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckComposedOr
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckComposedOr interface.
 */
export function instanceOfPaxCheckComposedOr(value: object): value is PaxCheckComposedOr {
    if (!('asText' in value) || value['asText'] === undefined) return false;
    if (!('requirements' in value) || value['requirements'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckComposedOrFromJSON(json: any): PaxCheckComposedOr {
    return PaxCheckComposedOrFromJSONTyped(json, false);
}

export function PaxCheckComposedOrFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckComposedOr {
    if (json == null) {
        return json;
    }
    return {
        
        'asText': json['as_text'],
        'requirements': ((json['requirements'] as Array<any>).map(PaxCheckChecklistItemRequirementFromJSON)),
        'type': json['type'],
    };
}

export function PaxCheckComposedOrToJSON(json: any): PaxCheckComposedOr {
    return PaxCheckComposedOrToJSONTyped(json, false);
}

export function PaxCheckComposedOrToJSONTyped(value?: PaxCheckComposedOr | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'as_text': value['asText'],
        'requirements': ((value['requirements'] as Array<any>).map(PaxCheckChecklistItemRequirementToJSON)),
        'type': value['type'],
    };
}

